"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Text = require("./Text");

Object.keys(_Text).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Text[key];
    }
  });
});